module.exports = __webpack_public_path__ + "resources/img/sp_member.83320447a4646dfccc3a9c40b61437b2.png";